import { BIRDVIEW_CHART_FLOW_SERIES } from '../../DashboardBirdview.constants.charts'

export function getBirdviewFlowTooltipRows({ payload, t }) {
  return BIRDVIEW_CHART_FLOW_SERIES.map(series => ({
    color: series.color,
    id: series.dataKey,
    isStrong: true,
    label: t(series.labelKey),
    value: payload.find(item => item.dataKey === series.dataKey)?.value,
  }))
}
